export enum ProcessEditorPrintType {
    GraphOnly,
    GraphAndData,
    GraphRisksAndControls,
}
